import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { IconButton, List, Text } from '@sayyesschool/frontend/ui-components';
import { wordEnding } from '@sayyesschool/frontend/utils/format';

const exerciseWordEnding = wordEnding('упражнени', ['е', 'я', 'й']);

export default function ListItem({ index, section, first, last, onMove, onDelete }) {
    const handleMoveUp = useCallback(event => {
        event.preventDefault();
        event.stopPropagation();

        onMove(index, -1);
    }, [index, onMove]);

    const handleMoveDown = useCallback(event => {
        event.preventDefault();
        event.stopPropagation();

        onMove(index, 1);
    }, [index, onMove]);

    const handleDelete = useCallback(event => {
        event.preventDefault();
        event.stopPropagation();

        onDelete(section);
    }, [section, onDelete]);

    return (
        <List.Item
            key={section.id}
            as={Link}
            to={section.uri}
            media={index + 1}
            content={<>
                <Text>{section.title}</Text>
                <Text type="body-sm">{section._exercises?.length} {exerciseWordEnding(section._exercises?.length)}</Text>
            </>}
            endAction={<>
                {!first &&
                    <IconButton
                        icon="arrow_upward"
                        color="neutral"
                        size="sm"
                        variant="plain"
                        onClick={handleMoveUp}
                    />
                }

                {!last &&
                    <IconButton
                        icon="arrow_downward"
                        color="neutral"
                        size="sm"
                        variant="plain"
                        onClick={handleMoveDown}
                    />
                }

                {onDelete &&
                    <IconButton
                        icon="delete"
                        color="neutral"
                        size="sm"
                        variant="plain"
                        onClick={handleDelete}
                    />
                }
            </>}
        />
    );
}